import { apiRequest } from 'api/apiClient';

const createEvent = async ({
  name,
  description,
  date,
  is_shareable_on_retailer_page,
  is_auth_required_for_comments,
  is_auth_required_to_join,
}) => {
  const response = await apiRequest('POST', '/v1/events', {
    name,
    description,
    date,
    is_shareable_on_retailer_page,
    is_auth_required_for_comments,
    is_auth_required_to_join,
  });
  return response;
};

const updateEvent = async ({
  uid,
  name,
  description,
  date,
  is_shareable_on_retailer_page,
  is_auth_required_for_comments,
  is_auth_required_to_join,
}) => {
  const response = await apiRequest('PATCH', `/v1/events/${uid}`, {
    name,
    description,
    date,
    is_shareable_on_retailer_page,
    is_auth_required_for_comments,
    is_auth_required_to_join,
  });
  return response;
};

const deleteEvent = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/events/${uid}`);
  return response;
};

const EVENTS_MUTATIONS = {
  CREATE_EVENT: createEvent,
  UPDATE_EVENT: updateEvent,
  DELETE_EVENT: deleteEvent,
};

export default EVENTS_MUTATIONS;
